import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable, throwError, race, timer } from "rxjs";
import { filter, mergeMap, catchError, take, map } from "rxjs/operators";
import { CustomErrorHandlerService } from "../api/custom-error-handler.service";

@Injectable()
export class UserInterceptorService implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private errorHandler: CustomErrorHandlerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // @NOTE: If you have some endpoints that are public
    // and do not need Authorization header, implement logic
    // here to accommodate that and conditionally let public
    // requests pass through based on your requirements

    // Race between getting user profile and a timeout of 1 second
    return race(
      this.auth.userProfile$.pipe(
        filter(prof => prof !== null && prof?.currentTenant?.tenant_id),
        take(1)
      ),
      timer(1000).pipe(
        map(() => {
          return null as any;
        }),
        take(1)
      )
    ).pipe(
      mergeMap((prof) => {
        try {
          if (req.url.includes(".s3.")) {
            return next.handle(req);
          }
          let tokenReq;
          if (prof?.currentTenant?.tenant_id) {
            const tenantId = prof.currentTenant.tenant_id;
            tokenReq = req.clone({
              setHeaders: {
                tenant_id: tenantId,
              },
            });
          } else {
            tokenReq = req.clone();
          }
          return next.handle(tokenReq);
        } catch (e) {
          console.error("UserInterceptor: Error processing user profile", e);
          return next.handle(req);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error("UserInterceptor: HTTP Error", error);
        return throwError((): HttpErrorResponse => this.errorHandler.tryParseError(error));
      })
    );
  }
}
